import { Injectable } from '@angular/core';
import { EntityManager, IEntity } from '@proximus/entity-manager';
import { Observable } from 'rxjs';
import {
  NspProductsInPackEntity,
  NspStandaloneProductsEntity,
  NspStatisticProductsEntity,
} from '../configs/entity.config';
import { INspStatistics } from '../utils/nsp.utils';

@Injectable({
  providedIn: 'root',
})
export class NspService {
  getNspProductsInPack(payload: any): Observable<IEntity<any>> {
    return EntityManager.getEntity(NspProductsInPackEntity, {
      packId: encodeURIComponent(payload.packId),
    });
  }

  getNspStandaloneProducts(payload: any): Observable<IEntity<any>> {
    return EntityManager.getEntity(NspStandaloneProductsEntity, {
      plc: payload.plcList,
      ...(payload.productId && {
        productId: encodeURIComponent(payload.productId),
      }),
    });
  }

  getNspStatisticsProducts(): Observable<IEntity<INspStatistics>> {
    return EntityManager.getEntity(NspStatisticProductsEntity);
  }
}
